import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PageMetaWithTotalSchema } from '../pagination';
import { DeviceOsSchema, DeviceRowSchema, DeviceStatusSchema } from './shapes';

export const DeviceListItemSchema = DeviceRowSchema.extend({
  coverThumbnailUrl: z.string().url().nullable(),
});
export type DeviceListItem = z.infer<typeof DeviceListItemSchema>;

const csvOrArray = <T extends z.ZodTypeAny>(inner: T) =>
  z.union([z.array(inner), inner]).transform((v) => (Array.isArray(v) ? v : [v]));

export const ListDevicesQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(25),
  cursor: z.string().optional(),
  q: z.string().trim().min(1).optional(),
  status: csvOrArray(DeviceStatusSchema).optional(),
  os: DeviceOsSchema.optional(),
  assignedUserId: z.union([z.string().uuid(), z.literal('none')]).optional(),
});

export const ListDevicesResponseSchema = z.object({
  data: z.array(DeviceListItemSchema),
  meta: PageMetaWithTotalSchema,
});

export const listDevices = defineEndpoint({
  method: 'GET',
  path: '/v1/devices',
  params: z.object({}),
  query: ListDevicesQuerySchema,
  body: z.undefined(),
  response: ListDevicesResponseSchema,
});
